import { TipStatus } from "../TipStatus";

export class UpdateTipStatusDto {
  public TipId!: number; // El tipId de la tip que se había creado
  public Status!: TipStatus; // Estado de la propina: APROBADA, CANCELADA o DECLINADA
  public AzulOrderId?: string; // Número de orden de Azul (solo para pagos aprobados)
  public CountryCode?: string; // Código del país (ej: "DO", "AR")
}

